import * as Dtos from '../../dtos/Tmd.dtos';

export const
    setEditModalViewState: ITrialItemsPageSetEditModalViewStateActionCreator = (open, collectionInstanceId, name, description) => {
        return {
            type: ACTION_TRIALITEMS_PAGE_SET_EDIT_MODAL_VIEW_STATE,
            open,
            collectionInstanceId,
            name,
            description
        }
    },
    setCreateVersionModalViewState: ITrialItemsPageSetCreateVersionModalViewStateActionCreator = (open, trialItem) => {
        return {
            type: ACTION_TRIALITEMS_PAGE_SET_CREATEVERSION_MODAL_VIEW_STATE,
            open,
            trialItem
        }
    }

export const
    ACTION_TRIALITEMS_PAGE_SET_EDIT_MODAL_VIEW_STATE = "ACTION_TRIALITEMS_PAGE_SET_EDIT_MODAL_VIEW_STATE",
    ACTION_TRIALITEMS_PAGE_SET_CREATEVERSION_MODAL_VIEW_STATE = "ACTION_TRIALITEMS_PAGE_SET_CREATEVERSION_MODAL_VIEW_STATE"

/* Actions */

export interface ITrialItemsPageSetEditModalViewStateAction {
    type: "ACTION_TRIALITEMS_PAGE_SET_EDIT_MODAL_VIEW_STATE",
    open: boolean;
    collectionInstanceId: number;
    name: string;
    description: string;
}

export interface ITrialItemsPageSetCreateVersionModalViewStateAction {
    type: "ACTION_TRIALITEMS_PAGE_SET_CREATEVERSION_MODAL_VIEW_STATE",
    open: boolean;
    trialItem: Dtos.TrialItem
}

/* Action Creators */

export interface ITrialItemsPageSetEditModalViewStateActionCreator {
    (
        open: boolean,
        collectionIntanceId: number,
        name: string,
        description: string
    ): ITrialItemsPageSetEditModalViewStateAction;
}

export interface ITrialItemsPageSetCreateVersionModalViewStateActionCreator {
    (
        open: boolean,
        trialItem: Dtos.TrialItem
    ): ITrialItemsPageSetCreateVersionModalViewStateAction;
}


/* Final Export of actions */
export type TrialItemsPageAction =
    ITrialItemsPageSetEditModalViewStateAction |
    ITrialItemsPageSetCreateVersionModalViewStateAction;
